/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import Helmet from 'react-helmet'
import { specialVideosStatus } from 'reduxModules/specialVideos'
import { specialVideoStateSelector as stateSelector } from 'reduxModules/specialVideos/selectors'
import { specialVideoDispatchers as dispatchers } from 'reduxModules/specialVideos/dispatchers'
import LoadingComponent from 'components/generic/LoadingComponent'
import Overview from 'components/SpecialVideos/SpecialVideoOverview'
import Chapters from 'components/SpecialVideos/SpecialVideoChapters'
import withRouterV6 from '../../../utils/withRouterV6'
import Banner from '../../generic/FeaturedElement/index.jsx'
import CourseTabs from '../../Courses/CourseTabs'
import SpecialVideoPlayer from '../../SpecialVideos/SpecialVideoPlayer'

import './styles.css'

export class SpecialVideoDetail extends Component {
  constructor(props) {
    super(props)
    this.setTabs = this.setTabs.bind(this)
    this.getLinkTo = this.getLinkTo.bind(this)
    this.state = {
      tabs: [],
      watchMode: false
    }
  }

  componentDidMount() {
    this.props.loadSpecialVideoInfo()
  }

  componentDidUpdate(prevProps) {
    const { params, location } = this.props
    const oldSlug = prevProps.params.specialVideoSlug
    const newSlug = params.specialVideoSlug

    // Handle slug change - clear and reload special video
    if (oldSlug !== newSlug) {
      this.props.clearSpecialVideo()
      this.props.loadSpecialVideoInfo()
      return // Don't process other updates when slug changes
    }

    // Update tabs when status or relevant props change
    if (this.props.status !== prevProps.status || this.props.chapters !== prevProps.chapters)
      this.setTabs(this.props)

    // Handle watch mode state changes
    const shouldBeWatchMode = location.query?.watch === '1'
    if (shouldBeWatchMode !== this.state.watchMode) {
      if (shouldBeWatchMode && !this.props.isAuth) {
        // User not authenticated, redirect away from watch mode
        this.props.router.push(location.pathname)
      } else {
        this.setState({ watchMode: shouldBeWatchMode })
      }
    }
  }

  componentWillUnmount() {
    this.props.clearSpecialVideo()
  }

  getLinkTo() {
    const { slug } = this.props
    const initialWatchPath = `/special-videos/${slug}?watch=1`

    return initialWatchPath
  }

  setTabs(newProps) {
    const overview = <Overview {...newProps} />
    const tabs = [{ name: 'Overview', content: overview }]

    if (newProps.chapters) {
      const chapters = <Chapters {...newProps} />
      tabs.push({ name: 'Chapters', content: chapters })
    }

    this.setState({ tabs })
  }

  render() {
    if (this.props.status !== specialVideosStatus.success)
      return <LoadingComponent />
    const { props } = this
    const subscribed = !_.isNull(props.subscription)
    return (
      <article id="SpecialVideoDetail">
        <Helmet>
          <title>{`${props.title} | Stan Winston School of Character Arts`}</title>
          <meta property="og:title" content={props.title} />
          <meta property="og:image" content={props.photo.original} />
          <meta content="article" property="og:type" />
        </Helmet>
        {props.photo && (
          <div className="header">
            {!this.state.watchMode && (
              <div className="wrapper">
                <Banner
                  title={props.title}
                  description={props.description}
                  photo={props.photo}
                  linkTo={this.getLinkTo()}
                  btn={{ text: 'Watch Video', action: this.getLinkTo() }}
                  isMobile={props.isMobile}
                />
              </div>
            )}
            {this.state.watchMode && this.props.id && (
              <div>
                <SpecialVideoPlayer
                  location={props.location}
                  artist={props.artist}
                  isAuth={props.isAuth}
                  slug={props.slug}
                  router={props.router}
                />
              </div>
            )}
          </div>
        )}
        {this.state.tabs && <CourseTabs tabs={this.state.tabs} />}
      </article>
    )
  }
}

export const SpecialVideoPropTypes = {
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  socialUrl: PropTypes.string,
  //
  id: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired,
  description: PropTypes.string,
  photo: PropTypes.objectOf(PropTypes.string).isRequired,
  //
  body: PropTypes.string,
  chapters: PropTypes.string,
  subtitles: PropTypes.arrayOf(PropTypes.string).isRequired,
  video: PropTypes.objectOf(PropTypes.string).isRequired,
  firstFrameImage: PropTypes.objectOf(PropTypes.string).isRequired
}

export const SpecialVideoDefaultProps = {
  socialUrl: '',
  description: '',
  body: '',
  chapters: ''
}

SpecialVideoDetail.propTypes = {
  ...SpecialVideoPropTypes,
  status: PropTypes.string.isRequired,
  loadSpecialVideoInfo: PropTypes.func.isRequired,
  location: PropTypes.shape({ hash: PropTypes.string }).isRequired
}

SpecialVideoDetail.defaultProps = {
  ...SpecialVideoDefaultProps
}

export default withRouterV6(connect(stateSelector, dispatchers)(SpecialVideoDetail))
